import { render } from "./IssuesSinglePage.vue?vue&type=template&id=53aabf98&scoped=true"
import script from "./IssuesSinglePage.vue?vue&type=script&lang=js"
export * from "./IssuesSinglePage.vue?vue&type=script&lang=js"

import "./IssuesSinglePage.vue?vue&type=style&index=0&id=53aabf98&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53aabf98"]])

export default __exports__